
$(function () {
    $(document).on("click", ".btnRemoveFile", function () {
        $($(this).data('input')).val(1);
        $($(this).data('hide')).hide();
        $('.btnRemoveFile').hide();
    });
    $(document).on("click", ".btnOpenFile", function () {
        $($(this).data('input')).trigger('click');
    });
    $(document).on("submit", '.ajaxForm', function (e) {
        e.preventDefault();
        $('#globalLoader').show();
        $.ajax({
            url: $(this).attr('action'),
            type: $(this).attr('method'),
            data: $(this).serializeArray(),
            success: function (response) {
                if (response.success) {
                    $('#alert-success').hide();
                    $('#alert-success span').html(response.success);
                    setTimeout(() => {
                        $('#alert-success').show();
                    }, 200);
                }
                try {
                    url = new URL(response.url);
                    if (url) {
                        window.location.href = url;
                    }
                } catch (_) {
                    if (response.ajax_update_html && response.ajax_update_id) {
                        $('#globalLoader').hide();
                        $('.modal').modal('hide');
                        $(response.ajax_update_id).fadeOut().html(response.ajax_update_html).fadeIn(300);
                    } else {
                        location.reload();
                    }
                }
            },
            error: function (response) {
                $('#globalLoader').hide();
                console.log(response);
                console.log(response.message);
                console.log(response.responseJSON.message);
                if (response.responseJSON.message) {
                    $('.modalAjaxFormError').html(response.responseJSON.message).hide().fadeIn();
                } else {
                    if (response.responseJSON.error) {
                        $('.modalAjaxFormError').html(response.responseJSON.error).hide().fadeIn();
                    } else {
                        $('.modalAjaxFormError').html("Une erreur est survenue").hide().fadeIn();
                    }
                }
                $('.is-invalid').removeClass('.is-invalid');
                $('.invalid-feedback').hide();
                if (response.responseJSON.errors) {
                    Object.keys(response.responseJSON.errors).forEach(key => {
                        $('#' + key + '_error').html(response.responseJSON.errors[key]).fadeIn();
                        $('#' + key).addClass('is-invalid');
                    });
                }
                if (response.errors) {
                    Object.keys(response.errors).forEach(key => {
                        $('#' + key + '_error').html(response.errors[key]).fadeIn();
                        $('#' + key).addClass('is-invalid');
                    });
                }
            },
        });
    });
    if ($('#locomotion_moyen')) {
        if ($('#locomotion_moyen').val() == 'bus' || $('#locomotion_moyen').val() == 'velo' || $('#locomotion_moyen').val() == 'apied') {
            $('#input_modele_couleur').hide();
        } else {
            $('#input_modele_couleur').show();
        }
    }
    $(document).on("change", '#locomotion_moyen', function (e) {
        if (this.value == 'bus' || this.value == 'velo' || this.value == 'apied') {
            $('#input_modele_couleur').hide();
        } else {
            $('#input_modele_couleur').show();
        }
    });
    $('#inputFilePhoto').on('change', function (e) {
        var remove = $(this).data('remove');
        var max = $(this).data('max');
        if (typeof max !== 'undefined') {
            console.log(this.files[0].type);
            if (this.files[0].size > max) {
                alert("Le fichier est trop volumineux");
                this.value = "";
            } else if (this.files[0].type != 'image/jpeg' && this.files[0].type != 'image/png') {
                alert("Le fichier doit être une image (jpg ou png)");
                this.value = "";
            } else {
                if (typeof remove !== 'undefined') {
                    $($(this).data('remove')).val(0);
                    setBase64(this.files[0], $($(this).data('img')), $($(this).data('show')));
                    // $($(this).data('show')).show();
                }
            }
        }
    });
    $('.documentFileEdit').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('id');
        if (typeof id !== 'undefined') {
            $(id).find('.documentFileEdit').hide();
            $(id).find('.documentFileNameTxt').hide();
            $(id).find('.documentFileName').removeClass('d-none');
        }
    });

    $('.documentFileRemove').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('id');
        if (typeof id !== 'undefined') {
            $($(this).data('remove')).val(0);
            $(id).find('.documentFileRemove').val(1);
            $(id).hide();
        }
    });

    $('#addProcheAidant').on('click', function (e) {
        e.preventDefault();
        $('#listProchesAidants').append($('#elProcheAidantNew').html());
        $('#listProchesAidants .select2PA').select2();
    });

    $('.removeProcheAidant').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.elProcheAidant').find('.inputRemoveProcheAidant').val(1);
        $(this).closest('.elProcheAidant').fadeOut();
    });

    $(document).on('click', '.removeProcheAidantNew', function (e) {
        e.preventDefault();
        $(this).closest('.elProcheAidantNew').fadeOut().remove();
    });
    $('.formIPAideEdit').on('submit', function (e) {
        $('#elProcheAidantNew').remove();
    });

    // Sélecteur MRC / Secteurs
    $(document).on('change', '.selectMrc', function (e) {
        var mrc_id = $(this).val();
        if ($(this).is(':checked')) {
            $('.selectSecteur-' + mrc_id).prop('checked', true);
        } else {
            $('.selectSecteur-' + mrc_id).prop('checked', false);
        }
        $('#mrc-' + mrc_id).removeClass('middle-checked');
        var checked = $('.selectSecteur-' + mrc_id + ':checked').length;
        $('.countSecteur-' + mrc_id).html(checked);
        $('#mrcSecteurs-' + mrc_id).css('display', 'flex');
    });

    $(document).on('change', '.selectSecteur', function (e) {
        var mrc_id = $(this).data('mrc');
        var checked = $('.selectSecteur-' + mrc_id + ':checked').length;
        $('.countSecteur-' + mrc_id).html(checked);
        // si nombre de secteurs cochés atteint le nombre de secteurs total alors on coche la MRC
        if (checked == $('.selectSecteur-' + mrc_id).length) {
            $('#mrc-' + mrc_id).prop('checked', true);

        } else {
            $('#mrc-' + mrc_id).prop('checked', false);
        }
        // si au moins un secteur est coché mais pas tous alors on ajoute la classe middle-checked à la checkbox de la MRC sinon on l'enleve
        if (checked > 0 && checked < $('.selectSecteur-' + mrc_id).length) {
            $('#mrc-' + mrc_id).addClass('middle-checked');
        } else {
            $('#mrc-' + mrc_id).removeClass('middle-checked');
        }

    });

    $(document).on('click', '.toggleSecteurs', function (e) {
        var div = $('#' + $(this).data('mrc'));

        div.toggle();

        if ($(this).find('.bi').hasClass('bi-chevron-right')) {
            $(this).find('.bi').removeClass('bi-chevron-right').addClass('bi-chevron-down');
        } else {
            $(this).find('.bi').removeClass('bi-chevron-down').addClass('bi-chevron-right');
        }
    }
    );


});

function setBase64(file, target, show) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        //   console.log(reader.result);
        target.attr('src', reader.result);
        show.show();
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}
